import {
  DashboardIcon,
  PeopleIcon,
  ToolboxIcon,
  twMerge,
} from '@pledge-earth/product-language';
import { FormattedMessage } from 'react-intl';

import {
  NavItem,
  NavItemLink,
  NavMenu,
  NavSection,
  NavSectionHeading,
} from '../Nav/Nav';
import { DotIcon } from '../SideBarSVG/DotIcon';

export function NavigationMenu({ className }: { className?: string }) {
  return (
    <div className={twMerge('flex flex-col gap-4', className)}>
      {/* menu body top section */}
      <div className="flex flex-1 flex-col gap-3">
        <NavSection>
          <NavMenu>
            <NavItem>
              <NavItemLink to="/dashboard">
                <DashboardIcon />
                <FormattedMessage id="leftMenu.home" />
              </NavItemLink>
            </NavItem>
            <NavItem>
              <NavItemLink to="/clients">
                <PeopleIcon />
                <FormattedMessage id="leftMenu.clients" />
              </NavItemLink>
            </NavItem>
          </NavMenu>
        </NavSection>

        <NavSection>
          <NavSectionHeading className="group-data-[menu-collapsed]/layout:opacity-0">
            <FormattedMessage id="leftMenu.data-collection" />
          </NavSectionHeading>
          <NavMenu>
            <NavItem>
              <NavItemLink to="/data-collection/configure-supplier-entitlements">
                <DotIcon />
                <FormattedMessage id="leftMenu.data-collection.configure-supplier-entitlements" />
              </NavItemLink>
            </NavItem>
            <NavItem>
              <NavItemLink to="/data-collection/link-import">
                <DotIcon />
                <FormattedMessage id="leftMenu.data-collection.link-import" />
              </NavItemLink>
            </NavItem>
            <NavItem>
              <NavItemLink to="/data-collection/submit-request-data">
                <DotIcon />
                <FormattedMessage id="leftMenu.data-collection.submit-request-data" />
              </NavItemLink>
            </NavItem>
          </NavMenu>
        </NavSection>
        <NavSection>
          <NavSectionHeading className="group-data-[menu-collapsed]/layout:opacity-0">
            <FormattedMessage id="leftMenu.tools" />
          </NavSectionHeading>
          <NavMenu>
            <NavItem>
              <NavItemLink to="/tools">
                <ToolboxIcon />
                <FormattedMessage id="leftMenu.tools" />
              </NavItemLink>
            </NavItem>
          </NavMenu>
        </NavSection>
      </div>
    </div>
  );
}
